import {GET_GRAPH} from '../types';
import {SET_TIMEFRAME_ACTIVE} from '../types';
import {SET_TIMEFRAMES} from '../types';

import axios from 'axios';

import {timeFrom, timeTo} from "../../utils/timeInterval";
import {domain, naturalUrlAttr} from "../../config";


export const getGraph = () => async dispatch => {

    try {
        const response = await axios.get(`${domain}api/trade/graph?from=${Math.floor(timeFrom)}&to=${Math.floor(timeTo)}`);

        const candles = response.data.map(candle => {
            let date = new Date(+candle.open_time);
            let daymth = date.getDate() + '_' + date.getMonth();

            return {
                open_time: +candle.open_time,
                daymth: daymth,
                candle: {
                    ...candle,
                    date: date,
                    open_time_number: +candle.open_time,
                    open_time: new Date(+candle.open_time),
                    close_time: new Date(+candle.close_time),
                    type: "Candle",
                    orders: [],
                }
            };
        });

        dispatch({
            type: GET_GRAPH,
            payload: candles
        });
    } catch (e) {
        console.log('Error graph');
    }
};

export const setActiveTimeframe = (activeTimeframe) => dispatch => {

    dispatch({
        type: SET_TIMEFRAME_ACTIVE,
        payload: activeTimeframe
    });
};
